import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";

const InputCheckbox = (props) => {
  const { value, onChange, label, className } = props;
  return (
    <div className={`input-checkbox ${className}`}>
      <FormControlLabel
        control={<Checkbox checked={value} onChange={onChange} />}
        label={label}
        classes={{ label: "custom-label" }}
      />
    </div>
  );
};

export default InputCheckbox;
